import React from "react";
import { BotonPrincipal } from "../componentes/btn";
import { Contacto } from "../componentes/contacto";
import { NavDesarrollo } from "../componentes/navDesarrollo";
import { BotonFlotante } from "../componentes/btnFlotante";
import { CardTrabajos } from "../componentes/cardTrabajos";
import { ReactComponent as SoftwareIcon } from "../img/desarrollo/servicios/software.svg";
import { ReactComponent as ConsultoriaIcon } from "../img/desarrollo/servicios/consultoria.svg";
import { ReactComponent as SolucionesCloudIcon } from "../img/desarrollo/servicios/solucionesCloud.svg";
import { ReactComponent as AsistentesVirtualesIcon } from "../img/desarrollo/servicios/asistentesVirtuales.svg";
import { Row, Col, Card } from "antd";
import zoho from "../img/desarrollo/integraciones/zoho.svg";
import botmaker from "../img/desarrollo/integraciones/botmaker.svg";
import img1 from "../img/desarrollo/tecnologias/wordpress.png";
import img2 from "../img/desarrollo/tecnologias/html5.png";
import img3 from "../img/desarrollo/tecnologias/react.png";
import img4 from "../img/desarrollo/tecnologias/figma.png";
import img5 from "../img/desarrollo/tecnologias/node.png";
import img6 from "../img/desarrollo/tecnologias/elementor.png";
import img7 from "../img/desarrollo/tecnologias/css.png";
import img8 from "../img/desarrollo/tecnologias/javaScript.png";
import img9 from "../img/desarrollo/tecnologias/php.png";
import img10 from "../img/desarrollo/tecnologias/express.png";
import img11 from "../img/desarrollo/tecnologias/ilustrator.png";
import img12 from "../img/desarrollo/tecnologias/corelDraw.png";
import asistentes from "../img/desarrollo/asistentes/asistentes.svg";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
export const Desarrollo = ({}) => {
  return (
    <>
      <NavDesarrollo />
      <BotonFlotante />
      {/*Header*/}
      <section
        id="headerDesarrollo"
        className="animate-slide-in"
        style={{
          height: "130vh",
        }}
      >
        <Row
          gutter={[16, 16]}
          style={{
            margin: 0,
            padding: 0,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Col
            className="col-responsive"
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={11}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              height: "100vh",
            }}
          >
            <h1 className="titulos">Desarrollo tecnológico </h1>
            <div className="typewriter-container titulos">
              <h1 className="typewriter">que impulsa tu negocio digital</h1>
            </div>

            <h5 className="subtitulos">
              Desarrollamos soluciones tecnológicas personalizadas que conectan
              tu visión con la innovación, optimizando cada paso del proceso
            </h5>
            <br />

            <BotonPrincipal
              text="Más información"
              colorFondo="#ffffff"
              colorTexto="#4B2C6A"
              className="boton-principal-desarrollo boton-centrado"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                textAlign: "center",
                alignSelf: "start",
              }}
              onClick={() => {
                const section = document.getElementById("contacto");
                section?.scrollIntoView({ behavior: "smooth" });
              }}
            />
          </Col>
          <Col
            className="col-responsive"
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={11}
            style={{
              display: "flex",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <DotLottieReact
              src="https://lottie.host/7fc685c2-0aac-4198-b979-6ed6fcf0e237/TavcICvsKt.lottie"
              loop
              autoplay
              className="lottie-header"
              style={{
                maxWidth: "15em",
                maxHeight: "auto",
                width: "15em",
                height: "auto",
              }}
            />
          </Col>
        </Row>
      </section>

      {/*Servicios */}
      <section
        id="servicios"
        style={{
          height: "100vh",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          padding: "20px",
        }}
      >
        <h1
          className="titulos-degrade-desarrollo"
          style={{ textAlign: "center" }}
        >
          Impulsá tu <b>negocio</b> hacia la <b>digitalización</b>
        </h1>{" "}
        <h5
          className="subtitulos-principales"
          style={{
            textAlign: "center",
            margin: "0 auto",
          }}
        >
          Apuesta a la competitividad y agilidad de tu negocio con soluciones
          digitales personalizadas
        </h5>
        <br></br>
        <br></br>
        <Row
          gutter={[12, 12]}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Col
            xs={24}
            sm={12}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <SoftwareIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />

                  <DotLottieReact
                    src="https://lottie.host/11ff1a4c-1646-45c1-b615-e09b5012deef/bgVcNIs8PO.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
                justifyContent: "center",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Software a medida
              </h3>
              <p className="textos-card">
                Soluciones web y aplicaciones móviles. Páginas Web Corporativas
              </p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <BotonPrincipal
                  text="Más información"
                  colorFondo="#4B2C6A"
                  colorTexto="#ffffff"
                  className="boton-principal-desarrollo boton-centrado"
                  onClick={() => {
                    const section = document.getElementById("contacto");
                    section?.scrollIntoView({ behavior: "smooth" });
                  }}
                />
              </div>
            </Card>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <ConsultoriaIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/11ff1a4c-1646-45c1-b615-e09b5012deef/bgVcNIs8PO.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Consultoría de sistemas
              </h3>
              <p className="textos-card">
                Pensamos y diseñamos procesos junto a nuestros clientes
              </p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <BotonPrincipal
                  text="Más información"
                  colorFondo="#4B2C6A"
                  colorTexto="#ffffff"
                  className="boton-principal-desarrollo boton-centrado"
                  onClick={() => {
                    const section = document.getElementById("contacto");
                    section?.scrollIntoView({ behavior: "smooth" });
                  }}
                />
              </div>
            </Card>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <AsistentesVirtualesIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/11ff1a4c-1646-45c1-b615-e09b5012deef/bgVcNIs8PO.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Asistenes virtuales
              </h3>
              <p className="textos-card">
                Integramos asistentes virtuales en tu página web y redes
                sociales
              </p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <BotonPrincipal
                  text="Más información"
                  colorFondo="#4B2C6A"
                  colorTexto="#ffffff"
                  className="boton-principal-desarrollo boton-centrado"
                  onClick={() => {
                    const section = document.getElementById("contacto");
                    section?.scrollIntoView({ behavior: "smooth" });
                  }}
                />
              </div>
            </Card>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              title={
                <div style={{ position: "relative", height: "100px" }}>
                  <SolucionesCloudIcon
                    className="icono-card"
                    style={{
                      position: "absolute",
                      top: "0.4em",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "5em",
                      zIndex: 2,
                    }}
                  />
                  <DotLottieReact
                    src="https://lottie.host/11ff1a4c-1646-45c1-b615-e09b5012deef/bgVcNIs8PO.lottie"
                    loop
                    autoplay
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "6em",
                      height: "6em",
                      borderRadius: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                    }}
                  />
                </div>
              }
              bordered={false}
              style={{
                position: "relative",
                overflow: "hidden",
                width: "300px",
                height: "auto",
                boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
                justifyContent: "center",
              }}
            >
              <h3 style={{ textAlign: "center" }} className="titulo-card">
                Soluciones Cloud
              </h3>
              <p className="textos-card">
                Solución de almacenamiento privado en la nube, F4 Cloud
              </p>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "1em",
                }}
              >
                <BotonPrincipal
                  text="Más información"
                  colorFondo="#4B2C6A"
                  colorTexto="#ffffff"
                  className="boton-principal-desarrollo boton-centrado"
                  onClick={() => {
                    const section = document.getElementById("contacto");
                    section?.scrollIntoView({ behavior: "smooth" });
                  }}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </section>

      {/*Tecnologías */}
      <section
        id="tecnologias"
        className="animate-slide-in"
        style={{
          height: "50vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "20px",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div className="scroll">
        <div>
            <img src={img1} alt="" className="img-des"/>
            <img src={img2} alt="" className="img-des"/>
            <img src={img3} alt="" className="img-des"/>
            <img src={img4} alt="" className="img-des"/>
            <img src={img5} alt="" className="img-des"/>
            <img src={img6} alt="" className="img-des"/>
            <img src={img7} alt="" className="img-des"/>
            <img src={img8} alt="" className="img-des"/>
            <img src={img9} alt="" className="img-des"/>
            <img src={img10} alt="" className="img-des"/>
            <img src={img11} alt="" className="img-des"/>
            <img src={img12} alt="" className="img-des"/>
           
        </div>

        <div>
        <img src={img1} alt="" className="img-des"/>
            <img src={img2} alt="" className="img-des"/>
            <img src={img3} alt="" className="img-des"/>
            <img src={img4} alt="" className="img-des"/>
            <img src={img5} alt="" className="img-des"/>
            <img src={img6} alt="" className="img-des"/>
            <img src={img7} alt="" className="img-des"/>
            <img src={img8} alt="" className="img-des"/>
            <img src={img9} alt="" className="img-des"/>
            <img src={img10} alt="" className="img-des"/>
            <img src={img11} alt="" className="img-des"/>
            <img src={img12} alt="" className="img-des"/>
       
        </div>
    </div>
      </section>

      {/*¿Querés la mejor web para tu negocio?  */}
      <section
        id="mejorWeb"
        style={{
          height: "100vh",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          padding: "0 80px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1
          className="titulos-degrade-desarrollo"
          style={{ textAlign: "center" }}
        >
          ¿Querés la mejor <b>web</b> para tu <b>negocio</b> ? <br />
          ¡Nosotros la hacemos realidad!
        </h1>
        <br />
        <h5
          className="subtitulos-principales"
          style={{
            textAlign: "center",
            margin: "0 auto",
          }}
        >
          Si sos emprendedor o profesional y querés una web que sea funcional,
          moderna y capaz de destacar tu marca, ¡estás en el lugar indicado! Nos
          especializamos en diseñar y desarrollar sitios que impulsan negocios
        </h5>
        <br />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            maxWidth: "400px",
            margin: "0 auto",
          }}
        >
          <BotonPrincipal
            text="Más información"
            colorFondo="#4B2C6A"
            colorTexto="#ffffff"
            className="boton-principal-desarrollo boton-centrado"
            style={{
              width: "100%",
              padding: "10px 20px",
              textAlign: "center",
              fontSize: "16px",
            }}
            onClick={() => {
              const section = document.getElementById("contacto");
              section?.scrollIntoView({ behavior: "smooth" });
            }}
          />
        </div>
      </section>

      {/*Asistentes Virtuales*/}
      <section
        id="asistentesVirtuales"
        style={{
          height: "100vh",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Row
          gutter={[16, 16]}
          align="middle"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            maxWidth: "1400px",
          }}
        >
          <Col xs={24} md={12}>
            <h2 className="titulos-blancos" style={{ textAlign: "left" }}>
              <b>Asistentes Virtuales</b>
            </h2>
            <br />
            <h5
              className="subtitulos-principales-blancos"
              style={{
                textAlign: "left",
                margin: "0 auto",
              }}
            >
              Optimizá tu tiempo y mejorá la atención al cliente con nuestros
              asistentes virtuales. Automáticamente resuelven consultas,
              programan tareas y están disponibles 24/7 para ayudar a tu negocio
              a crecer
            </h5>
            <br />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                justifyContent: "flex-start",
              }}
            >
              <div className="blur-button" style={{ animationDelay: "0.5s" }}>
                <span className="check-icon">✔</span>
                <span>Automatización</span>
              </div>
              <div className="blur-button" style={{ animationDelay: "1s" }}>
                <span className="check-icon">✔</span>
                <span>Optimización</span>
              </div>
              <div className="blur-button" style={{ animationDelay: "1.5s" }}>
                <span className="check-icon">✔</span>
                <span>Productividad</span>
              </div>
            </div>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={asistentes}
              alt="Asistentes Virtuales"
              style={{
                maxWidth: "100%",
                height: "auto",
                animation: "float 5s ease-in-out infinite",
              }}
            />
          </Col>
        </Row>
      </section>

      {/*Casos de éxito */}
      <section
        id="casosExito"
        style={{
          height: "auto",
          marginBottom: "1em",
          display: "flex",
          flexDirection: "column",
          padding: "0 20px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1
          className="titulos-degrade-desarrollo"
          style={{ textAlign: "center" }}
        >
          Casos de <b>éxito</b>
        </h1>
        <br />
        <CardTrabajos />
        <br></br>
        <br></br>
      </section>

      {/*Partners*/}
      <section
        id="partners"
        style={{
          height: "100vh",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          padding: "0 20px",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <h2
          className="titulos-blancos"
          style={{
            textAlign: "center",
            marginBottom: "10px",
          }}
        >
          Impulsando la <b>innovación</b> con nuestros{" "}
          <b>socios tecnológicos</b>
        </h2>
        <h5
          className="subtitulos-principales-blancos"
          style={{
            textAlign: "center",
            marginBottom: "20px",
            maxWidth: "1200px",
          }}
        >
          A través de nuestras alianzas estratégicas con líderes del sector
          tecnológico, estamos construyendo soluciones innovadoras que
          transforman la manera en que las empresas operan, optimizando procesos
          y maximizando el impacto digital.
        </h5>
        <div
          style={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
          }}
        >
          <div
            className="blur-button"
            style={{
              animationDelay: "0s",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "300px",
            }}
          >
            <a
              href="https://www.zoho.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={zoho}
                alt="Zoho"
                className="brand-logo"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            </a>
          </div>
          <div
            className="blur-button"
            style={{
              animationDelay: "0.5s",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "300px",
            }}
          >
            <a
              href="https://www.botmaker.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={botmaker}
                alt="BotMaker"
                className="brand-logo"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            </a>
          </div>
        </div>
      </section>

      {/*Contacto*/}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          boxSizing: "border-box",
          padding: "0 80px",
        }}
        id="contacto-footer-desarrollo"
        className="section-contacto-footer "
      >
        <div id="contacto-desarrollo">
          <Contacto tituloColor="#4B2C6A" botonColor={["#9456D0", "#4B2C6A"]} />
        </div>
      </section>
    </>
  );
};

export default Desarrollo;
